import classNames from 'classnames';
import { useEffect, useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/nova/theme.css';
import { useNavigate } from 'react-router';

type Props = {
    nmPessoa: string,
    nmSetor: string,
    menuAberto: boolean
}

export default function AppInlineProfile(props: Props) {

    const navigate = useNavigate();

    const [expanded, setExpanded] = useState<boolean>(false);
    const [nmPessoa, setNmPessoa] = useState<string>(props.nmPessoa);
    const [nmSetor, setNmSetor] = useState<string>(props.nmSetor);

    useEffect(() => {
    }, []);

    function onClick(e: any) {
        setExpanded(!expanded);
        e.preventDefault();
    }

    function clickSair() {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    function clickPerfil() {
        navigate('/usuario/perfil');
        return false;
    }

    return (<>

        <div className="profile">
            <a className='profile-info' onClick={(e) => onClick(e)} href='/'>
                <img src="/foto.png" className="profile-img" />
                <div className='user-info'>
                    <div className="profile-link" >
                        <span className="username">{nmPessoa}</span>
                        <i className="fa fa-fw fa-cog" />
                    </div>
                    {nmSetor?<span className="setor">{nmSetor}</span>:null}
                </div>
            </a>
            <ul className={classNames({ 'profile-expanded': expanded && props.menuAberto })}>
                <li><a onClick={() => clickPerfil()}><i className="fa fa-fw fa-user" /><span>Perfil</span></a></li>
                <li><a onClick={() => clickSair()} href='/'><i className="fa fa-fw fa-sign-out" /><span>Sair</span></a></li>
            </ul>
        </div>
    </>
    );

}